
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-18076.6 -2945.847 18.248 17.047"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Group_6901","data-name":"Group 6901","transform":"translate(-19123 -3474)","opacity":".64"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Line_1730","d":"M0 11.1L9.9 0","data-name":"Line 1730","transform":"translate(1053.9 529)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3552","d":"M.6 9.3l14.5 5.1L17.5.6z","data-name":"Path 3552","transform":"translate(1046.4 528.4)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3553","d":"M10.1 12.6l-2.5 3.6v-4.6","data-name":"Path 3553","transform":"translate(1046.4 528.4)"}})])])
          )
        }
      }
    